module.exports = __webpack_public_path__ + "img/4door_stopped.f69b859b.svg";